import React, { Component } from 'react';

import FlatButton from 'material-ui/FlatButton';

import SignatureCanvas from 'react-signature-canvas';
import { localize } from 'react-localize-redux';

import { AccentColor } from 'helpers/AccentColorHelper';

const style = {
  subheader_side_padding: {
    padding: '0 16px',
    textAlign: 'center',
  },
};

class FinishJobFormStep2 extends Component {
  constructor(props) {
    super(props);
    this.state = { trimmedDataURL: null, signed: false };
    this.sigPad = {};
  }

  clear = () => {
    this.sigPad.clear();
    this.props.enableSignButton(false, null);
  };

  render() {
    const BREAK_POINT = 466;
    const MARGIN_RATIO = 36;

    let canvas_width = 275;
    if (this.props.signaturePageWidth < BREAK_POINT) {
      canvas_width =
        canvas_width * (this.props.signaturePageWidth / BREAK_POINT) -
        (1 - this.props.signaturePageWidth / BREAK_POINT) * MARGIN_RATIO;
    }

    return (
      <div>
        <div className="row" style={style.subheader_side_padding}>
          <div className="row" style={{ marginTop: '-10px' }}>
            <p style={{ fontSize: '13px' }}>
              By signing below, you verify that the work required for this ticket has been
              completed..
            </p>
          </div>
          <div className="row" style={{ width: canvas_width, margin: '10px auto 0' }}>
            <SignatureCanvas
              penColor="black"
              ref={ref => {
                this.sigPad = ref;
              }}
              onEnd={() => {
                this.props.enableSignButton(
                  true,
                  this.sigPad.getTrimmedCanvas().toDataURL('image/png')
                );
              }}
              canvasProps={{
                width: canvas_width,
                height: 180,
                className: 'signature-canvas',
              }}
            />
            <FlatButton
              label="Clear"
              type="button"
              className="Create Ticket"
              onClick={this.clear}
              backgroundColor="#fff"
              hoverColor="grey"
              style={{
                color: AccentColor(),
                height: '40px',
                float: 'left',
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default localize()(FinishJobFormStep2);
